<template>
    <div class="flex flex-col aspect-square">
        <div class="relative w-full h-full">
            <NuxtImg v-if="image" format="webp" sizes="200px" :src="image" class="w-full h-full object-contain" />
            <p v-else-if="index" class="flex justify-center items-center w-full h-full object-contain text-4xl">
                {{ index }}
            </p>
        </div>
        <div v-if="loading">
            <Icon name="svg-spinners:3-dots-bounce" class="block mx-auto size-5! text-primary" />
        </div>
        <div v-else-if="title" class="mt-2 text-center">
            <h5 v-if="title.title" class="opacity-75 text-xs leading-2">{{ $t(`product.${title.title}.label`) }}</h5>
            <p v-if="title.value" class="font-bold capitalize">{{ $t(`product.${title.title}.${title.value}`, title.value) }}</p>
        </div>
    </div>
</template>

<script lang="ts" setup>
interface Title {
    title?: string;
    value?: string;
}

interface Props {
    title?: Title;
    image?: string;
    index?: number;
    loading?: boolean;
}

defineProps<Props>();
</script>
